import React from "react";
import "./Versioning.css";
import versioning from "./assets/versioning.png";
import Logo from "../../../common/logo/Logo";

function Versioning() {
  return (
    <header className="app-header">
      <div className="app-container features-container">
        <div className="logo-box" style={{ marginBottom: "3rem" }}>
          <Logo navigateTo={"/GitVersioniser/features"} />
        </div>
        <div
          className="container"
          style={{ width: "100%", marginBottom: "3rem" }}
        >
          <div className="row flex">
            <div className="col-sm-12" style={{ alignSelf: "center" }}>
              <h1>Declarative Semantic Versioning.</h1>
              <br />
              <p>
                New versions are created with an incrementation tag in the
                commit message.
              </p>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row flex">
            <div className="col-sm-12">
              <img
                src={versioning}
                alt="Git Versioniser Logo"
                className="feature-image"
                style={{ width: "19em" }}
              />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Versioning;
